export default {
  menu: (state) => state.menu,
  title: (state) => state.title,
  image: (state) => state.image,
  hasValidLicense: (state) => state.hasValidLicense,
};
